module.exports = __webpack_public_path__ + "media/images/flags/mp-e142ed585629b9957b0f8eff2d3d7ac2.svg";